import { render, staticRenderFns } from "./ResourceViewTimeline.vue?vue&type=template&id=185d4cfa&scoped=true"
import script from "./ResourceViewTimeline.vue?vue&type=script&lang=js"
export * from "./ResourceViewTimeline.vue?vue&type=script&lang=js"
import style0 from "./ResourceViewTimeline.vue?vue&type=style&index=0&id=185d4cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185d4cfa",
  null
  
)

export default component.exports